"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var mountAndShowFullOptions_1 = require("../../utils/mountAndShowFullOptions");
var mobx_react_1 = require("mobx-react");
var owa_options_strings_1 = require("owa-strings/owa-options-strings");
var React = require("react");
var Button_1 = require("office-ui-fabric-react/lib/Button");
var styles = require('./QuickOptions.scss');
var classNames = require('classnames/bind').bind(styles);
var QuickOptionSearchEntry = /** @class */ (function (_super) {
    tslib_1.__extends(QuickOptionSearchEntry, _super);
    function QuickOptionSearchEntry() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.onHeaderClick = function () {
            mountAndShowFullOptions_1.default(_this.props.option.categoryKey, _this.props.option.subcategoryKey, _this.props.option.key);
            if (_this.props.onDismiss) {
                _this.props.onDismiss();
            }
        };
        return _this;
    }
    QuickOptionSearchEntry.prototype.render = function () {
        var option = this.props.option;
        return (React.createElement("div", { className: styles.quickSetting },
            React.createElement(Button_1.CommandButton, { text: owa_options_strings_1.default[option.titleStringKey], className: classNames(styles.quickSettingHeader, styles.isSearch), onClick: this.onHeaderClick })));
    };
    QuickOptionSearchEntry = tslib_1.__decorate([
        mobx_react_1.observer
    ], QuickOptionSearchEntry);
    return QuickOptionSearchEntry;
}(React.Component));
exports.default = QuickOptionSearchEntry;
//# sourceMappingURL=QuickOptionSearchEntry.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/options/view/owa-options-view/lib/components/quick/QuickOptionSearchEntry.js
// module id = 3720
// module chunks = 2